import Link from '@/core/components/Link/Link';

export default Link;
